import React, {ReactElement} from "react";
import {jsx, Interpolation} from "@emotion/react";
import {Theme} from "./internal";

type ElementProps = {css?: Interpolation<Theme>};

export function cloneElement<Props extends ElementProps>(
  child: ReactElement,
  props: Props
): ReactElement<Props> {
  if (child.props.css) {
    return React.cloneElement(child, {
      ...props,
      css: (theme: Theme) => [
        child.props.css instanceof Function
          ? child.props.css(theme)
          : child.props.css,
        props.css,
      ],
    });
  }
  return jsx(child.type, {
    key: child.key,
    ...child.props,
    ...props,
  });
}
